import Web3 from 'web3'

const pattern = new RegExp(
  '^(https?:\\/\\/)?' + // protocol
  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
  '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
  '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
  '(\\#[-a-z\\d_]*)?$',
  'i'
); // fragment locator

export const MakeAmountStyle = (number, is_token_based = false) => {
  if (is_token_based === true) number = number / Math.pow(10, 6); // depends on token decimal
  var styledNumber;
  var unit;
  if (number > 1000000000000) {
    styledNumber = number / 1000000000000;
    unit = 'T';
  }
  if (number > 1000000000 && number <= 1000000000000) {
    styledNumber = number / 1000000000;
    unit = 'G';
  }
  if (number > 1000000 && number <= 1000000000) {
    styledNumber = number / 1000000;
    unit = 'M';
  }
  if (number > 1000 && number <= 1000000) {
    styledNumber = number / 1000;
    unit = 'K';
  }
  if (number <= 1000) {
    styledNumber = number;
    unit = '';
  }

  if (!Number.isInteger(styledNumber))
    styledNumber = styledNumber.toFixed(1);

  return styledNumber.toString() + unit;
}

export const dealPriceFormValidation = (
  price,
  setTextFieldError
) => {
  let isError = false
  let errors = {}

  if (price <= 0)
    errors.price = true

  let length = Object.keys(errors).length
  if (length !== 0)
    isError = true

  setTextFieldError({ ...errors });

  return isError;
}

export const stakeAmountFormValidation = (
  amount,
  min,
  max,
  setTextFieldError
) => {
  let isError = false
  let errors = {}

  if (amount < min || (max > 0 && amount > max) || amount === 0)
    errors.amount = true

  if (amount === 0)
    errors.overZero = true

  if (amount < min)
    errors.minAmount = true

  if (max > 0 && amount > max)
    errors.maxAmount = true

  let length = Object.keys(errors).length
  if (length !== 0)
    isError = true

  setTextFieldError({ ...errors });

  return isError;
}

export const dealFormValidation = (
  dealData,
  setTextFieldError,
  status
) => {
  let isError = false
  let errors = {}

  if (status === "new") {
    if (dealData.name.length <= 2)
      errors.name = true

    if (dealData.crypto === '')
      errors.crypto = true

    if (Number(dealData.offerPeriod) <= 0)
      errors.offerPeriod = true
  }

  if (dealData.websiteUrl !== '' && !pattern.test(dealData.websiteUrl))
    errors.websiteUrl = true

  if (Number(dealData.minStakeAmount) < 0)
    errors.minStakeAmount = true

  if (Number(dealData.maxStakeAmount) > 0 && Number(dealData.maxStakeAmount) < Number(dealData.minStakeAmount))
    errors.maxStakeAmount = true

  if (dealData.leadInvestor !== '' && !Web3.utils.isAddress(dealData.leadInvestor))
    errors.leadInvestor = true

  if (Number(dealData.presailAmount) <= 0)
    errors.presailAmount = true

  if (Number(dealData.minsaleAmount) <= 0)
    errors.minsaleAmount = true

  if (Number(dealData.maxsaleAmount) <= 0 || Number(dealData.maxsaleAmount) < Number(dealData.minsaleAmount) || Number(dealData.maxsaleAmount) < Number(dealData.presailAmount))
    errors.maxsaleAmount = true

  if (Number(dealData.startBonus) < 0 || Number(dealData.startBonus) < Number(dealData.endBonus))
    errors.startBonus = true

  if (Number(dealData.endBonus) < 0 || Number(dealData.startBonus) < Number(dealData.endBonus))
    errors.endBonus = true

  let length = Object.keys(errors).length
  if (length !== 0)
    isError = true

  setTextFieldError({ ...errors });

  return isError;
}

export const makeDealCSVData = (data, presaleAmount, maxsaleAmount, dealPrice) => {
  let csvData = [['NO', 'STAKER ADDRESS', 'VALUE OF STAKES', 'AMOUNT OF SHARES AT OFFER PRICE', 'BONUS AMOUNT']]
  data.map((info, index) => {
    if(maxsaleAmount >= info.stakedAmount) {
      let isOverStake = false
      let isClaimable = true
      let avgBonus = info.bonus
      const amount = Number(info.amount) + Number(info.restAmount)
      let overAmount = amount
  
      isOverStake = presaleAmount > info.stakedAmount && presaleAmount < info.stakedAmount + amount
  
      isClaimable = maxsaleAmount > info.stakedAmount + amount
  
      if (isOverStake) {
        const restAmount = presaleAmount - info.stakedAmount;
        if (!isClaimable) {
          overAmount = maxsaleAmount - info.stakedAmount;
        }
        avgBonus = restAmount / overAmount * info.bonus;
      }
  
      if (overAmount > 0) {
        let tmp = [
          index + 1,
          info.staker,
          overAmount / Math.pow(10, 6),
          Number((overAmount / Math.pow(10, 6) / dealPrice).toFixed(2)),
          avgBonus / 100
        ];
        csvData.push(tmp)
      }
    }

    return true;
  });

  return csvData;
}

export const makeOfferPeriod = (hours) => {
  const _hours = hours % 24;
  const _days = _hours === 0 ? hours / 24 : Math.ceil(hours / 24) - 1;
  const str_days = _days < 1 ? '' : _days + (_days > 1 ? ' Days ' : ' Day ')
  const str_hours = _hours === 0 ? '' : _hours <= 1 ? '1 Hour' : _hours + ' Hours'

  return str_days + str_hours;
}

export const isValidUrl = (url) => {
  return pattern.test(url)
}